import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  AuthService,
  BackendInterceptor,
  BackendRerouteService,
  CustomerService,
  Order,
  OrderToBasketService,
  PdfDownloadIndicatorService,
  SelectedCustomerService
} from 'gung-standard';
import { ActionButton } from 'gung-common';
import { JeevesOrderActionConfigService } from 'gung-standard-jeeves';
import { first, map, Observable, switchMap } from 'rxjs';
import { CultUnifaunReturnsService } from './cult-unifaun-returns.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CultOrderActionConfigService extends JeevesOrderActionConfigService {
  cult = [{ title: 'DOWNLOAD_SHIPMENT_PDF', action: (item: Order) => this.downloadShipmentPdf(item) }];

  constructor(
    protected cultUnifaunReturnsService: CultUnifaunReturnsService,
    protected backendRerouteService: BackendRerouteService,
    protected selectedCustomerService: SelectedCustomerService,
    protected customerService: CustomerService,
    protected orderToBasketService: OrderToBasketService,
    protected modalService: NgbModal,
    protected router: Router,
    protected authService: AuthService,
    protected pdfDownloadIndicatorService: PdfDownloadIndicatorService,
    protected http: HttpClient,
    protected backendInterceptor: BackendInterceptor
  ) {
    super(backendRerouteService, selectedCustomerService, customerService, orderToBasketService, modalService, router, pdfDownloadIndicatorService, http, backendInterceptor);
  }
  getButtons(item: Order): Observable<ActionButton<Order>[]> {
    return this.authService.getRoles().pipe(first(), map(roles => {
      // IF order details then do not show the go to order details button
      // Otherwise show the go to order details button
      // e.g: path of order details like /orders/orderId
      if (roles.includes('SHOW_ONLY_RETURNS')) {
        this.base = this.base.filter(b => b.title !== 'COPY_TO_CART');
      }
      if (roles.includes('RETUR_NOPRICE')) {
        this.base = this.base.filter(b => b.title !== 'PDF' && b.title !== 'XLSX');
      }

      const cultSpecificOrderButtons = item.extra.oh?.godsmarke1 ? this.cult : [];
      if (!!this.router.url && this.router.url.indexOf('/orders/') < 0) {
          const base = this.base?.filter(b => b.title !== 'PDF' && b.title !== 'XLSX') || [];
          return [...base, ...this.extra, ...cultSpecificOrderButtons];
      } else {
          return [...this.base, ...cultSpecificOrderButtons];
      }
    }));
  }

  downloadShipmentPdf(item: Order) {
    const shipmentNo = item.extra.oh.godsmarke1;
    if (shipmentNo) {
      this.backendRerouteService.reroute(this.cultUnifaunReturnsService.getPrintsForShipmentNoUrl(shipmentNo));
    } else {
      alert('No shipments could be found');
    }
  }
}
